<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="4" :lg="4">
          <el-input placeholder="手机号" v-model="mobile" clearable @clear="keywordsSearch" @keyup.enter.native="keywordsSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-签到奖励列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-table :data="signinData" :height="wheight-210"  v-loading="loading">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="user_id" label="会员ID" width="100"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="150"></el-table-column>
        <el-table-column prop="activity_id" label="活动ID" width="100"></el-table-column>
        <el-table-column prop="act_name" label="活动名称" width="200"></el-table-column>
        <el-table-column prop="awards_content" label="奖励内容" width="300"></el-table-column>
        <el-table-column prop="send_status" label="发放状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.send_status=='1'">已发放</el-tag>
            <el-tag v-else type="danger">未发放</el-tag>
          </template>
        </el-table-column>
         <el-table-column prop="err_msg" label="错误信息">
          <template slot-scope="scope">
            {{scope.row.err_msg}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="start_time" label="开始时间" width="180">
          <template slot-scope="scope" v-if="scope.row.act_type=='f'">
            {{scope.row.start_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="end_time" label="结束时间" width="180">
          <template slot-scope="scope" v-if="scope.row.act_type=='f'">
            {{scope.row.end_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column> -->
        <el-table-column prop="create_time" label="发放时间" width="180">
          <template slot-scope="scope">
            {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop="is_send" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="sendMsg(scope.row)" :disabled="scope.row.send_status == '1'">补发</el-button>
            <!-- <el-button type="primary" size="mini" @click="sendMsg(scope.row)">补发</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {
  signinaward,
  signinawardExport,
  resendSigninAward
} from '../../../api/members_sign'
export default {
  data () {
    return {
      id: [],
      amount_total: 0,
      total_count: 0,
      loading: false,
      exportLoading: false,
      btnLoading: false,
      signinData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      mobile: '',
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getSigninList (filter) {
      this.loading = true
      signinaward(filter).then(response => {
        this.signinData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.amount_total = response.data.data.amount_total
        this.loading = false
        this.exportLoading = false
      })
    },
    getParams () {
      this.params.mobile = this.mobile
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      // console.log(this.params)
      this.getSigninList(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    keywordsSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getSigninList(this.params)
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      signinawardExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-签到奖励列表中下载'
          })
          return
        } else if (response.data.data.url) {
          this.downloadUrl = response.data.data.url
          this.downloadName = response.data.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    },
    handleCancelLabelsDialog2 () {
      this.editInfoDialog2 = false
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getSigninList(this.params)
    },
    sendMsg(row) {
      this.$confirm('确定要重新发送签到奖励吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        resendSigninAward({
          id: row.id
        }).then(response => {
          this.loading = false
          if (response.data.success === true || response.data.code === 0) {
            this.$message({
              type: 'success',
              message: response.data.message || response.data.msg || '重新发送成功'
            })
            // 刷新列表
            this.getSigninList(this.params)
          } else {
            this.$message({
              type: 'error',
              message: response.data.message || response.data.msg || '重新发送失败'
            })
            this.getSigninList(this.params)
          }
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '网络错误，请稍后重试'
          })
        })
      }).catch(() => {
        // 取消操作
      })
    }
  },
  mounted () {
    this.getSigninList(this.params)
    let params = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    signinData: {
      handler (value) {
        if (this.allCheck) {
          this.signinData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}
.recharge-overview {
  .iconfont {
    font-size: 30px;
    color: #ff5000;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// signinaward.vue?46b753c0